import { Save, Undo2, Redo2, RefreshCw, Loader2 } from "lucide-react";

/**
 * Presentational per-section toolbar. Parent owns state.
 * Renders Save / Undo / Redo / Regenerate buttons.
 */
export const SectionToolbar = ({
  sectionKey,
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  onSaveVersion,
  onRegenerate,
  regenerating = false,
  disabled = false,
}) => (
  <div className="mvp-section-toolbar" data-testid={`section-toolbar-${sectionKey}`}>
    <button
      className="mvp-icon-btn"
      onClick={onUndo}
      disabled={disabled || !canUndo}
      title="Undo (this section)"
      data-testid={`section-undo-${sectionKey}`}
    >
      <Undo2 size={15} />
    </button>
    <button
      className="mvp-icon-btn"
      onClick={onRedo}
      disabled={disabled || !canRedo}
      title="Redo (this section)"
      data-testid={`section-redo-${sectionKey}`}
    >
      <Redo2 size={15} />
    </button>
    <button
      className="mvp-icon-btn"
      onClick={onSaveVersion}
      disabled={disabled}
      title="Save a version snapshot now"
      data-testid={`section-save-${sectionKey}`}
    >
      <Save size={15} />
    </button>
    <button
      className="mvp-icon-btn mvp-icon-btn-accent"
      onClick={onRegenerate}
      disabled={disabled || regenerating}
      title="Regenerate this section with Claude"
      data-testid={`section-regenerate-${sectionKey}`}
    >
      {regenerating ? <Loader2 size={15} className="mvp-spin" /> : <RefreshCw size={15} />}
    </button>
  </div>
);
